// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-22c3455e] .list-skeleton-item{height:320px;border-radius:8px}@media(min-width:768px){[data-v-22c3455e] .list-skeleton-item{height:400px}}.skeleton[data-v-22c3455e]{display:grid;grid-gap:24px;gap:24px}@media(min-width:768px){.skeleton[data-v-22c3455e]{grid-template-columns:1fr 1fr;grid-gap:16px;gap:16px}}@media(min-width:1200px){.skeleton[data-v-22c3455e]{grid-gap:24px;gap:24px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
